import { z } from 'zod';
import { paginationMetaSchema } from '@/api/pagination';
import {
  optionalDateSchema,
  optionalPositiveIdSchema,
  optionalTextSchema,
} from '@/utils/searchParams';

export const leaveReportSearchSchema = z.object({
  dateFrom: optionalDateSchema,
  dateTo: optionalDateSchema,
  divisionId: optionalPositiveIdSchema,
  districtId: optionalPositiveIdSchema,
  thanaId: optionalPositiveIdSchema,
  departmentId: optionalPositiveIdSchema,
  search: optionalTextSchema,
});

const leaveReportItemSchema = z.object({
  userId: z.coerce.number(),
  company: z.string().nullable(),
  division: z.string().nullable(),
  department: z.string().nullable(),
  district: z.string().nullable(),
  thana: z.string().nullable(),
  reportingToId: z.coerce.number().nullable(),
  reportingToName: z.string().nullable(),
  reportingToHrEmpId: z.string().nullable(),
  hrEmpId: z.string().nullable(),
  employeeName: z.string().nullable(),
  presentDays: z.coerce.number(),
  absentDays: z.coerce.number(),
  weekendDays: z.coerce.number(),
  holidayDays: z.coerce.number(),
  totalDays: z.coerce.number(),
  appliedDays: z.coerce.number(),
  unappliedDays: z.coerce.number(),
});

export const paginatedLeaveReportSchema = z.object({
  data: z.array(leaveReportItemSchema),
  meta: paginationMetaSchema,
});

export const leaveReportDatesSchema = z.object({
  present: z.array(z.string()),
  absent: z.array(z.string()),
  weekend: z.array(z.string()),
  holiday: z.array(z.string()),
  total: z.array(z.string()),
  applied: z.array(z.string()),
  unapplied: z.array(z.string()),
});

export type LeaveReportSearch = z.infer<typeof leaveReportSearchSchema>;
export type LeaveReportItem = z.infer<typeof leaveReportItemSchema>;
export type PaginatedLeaveReport = z.infer<typeof paginatedLeaveReportSchema>;
export type LeaveReportDates = z.infer<typeof leaveReportDatesSchema>;
type LeaveReportDateKey = keyof LeaveReportDates;
export type LeaveReportDateCategory = Exclude<LeaveReportDateKey, 'present'>;
export type LeaveReportDayKind = Exclude<LeaveReportDateKey, 'total'>;

export interface LeaveReportDateSelection {
  employee: LeaveReportItem;
  category: LeaveReportDateCategory;
}

export interface LeaveReportPeriod {
  dateFrom: string;
  dateTo: string;
}

export interface LeaveReportParams extends LeaveReportPeriod {
  divisionId?: number | undefined;
  districtId?: number | undefined;
  thanaId?: number | undefined;
  departmentId?: number | undefined;
  search?: string | undefined;
}
